export const defaultSettings = {
  backgroundActive: false,
  borderActive: false,
  borderColor: '#cccccc',
  borderWidth: '1',
  borderStyle: 'solid',
  borderRadius: '5',
  backgroundColor: '#eeeeee'
};
